<script>
import { mapState, mapActions } from 'vuex';
import utility from '../../mixins/utility';

export default {
  name: 'AffiliatesManage',
  mixins: [
    utility,
  ],
  data() {
    return {
      localAffiliate: undefined,
      snackbarShow: false,
      snackbarText: '',
    };
  },
  computed: {
    ...mapState({
      affiliate: state => state.affiliates.affiliate.item,
      error: state => state.affiliates.affiliate.error,
    }),
    validInput() {
      return this.localAffiliate.username &&
        this.localAffiliate.username.length >= 6 &&
        this.localAffiliate.name &&
        this.localAffiliate.token &&
        this.localAffiliate.token.length >= 32;
    },
  },
  methods: {
    ...mapActions({
      updateAffiliate: 'affiliates/updateAffiliate',
    }),
    generateToken() {
      this.localAffiliate.token = this.generateRandomString(32);
    },
    saveAffiliate() {
      this.updateAffiliate({
        id: this.affiliate.id,
        params: this.localAffiliate,
      }).then(() => {
        if (this.error) {
          this.snackbarText = 'Unable to update the affiliate';
          this.snackbarShow = true;
        }
      });
    },
  },
  watch: {
    affiliate() {
      if (this.affiliate) {
        this.localAffiliate = Object.assign({}, this.affiliate);
      } else {
        this.localAffiliate = undefined;
      }
    },
  },
};
</script>

<template>
  <v-flex v-if="localAffiliate" xs12>
    <v-layout wrap mt-4>
      <v-flex xs12 mt-4 mb-2>
        <span class="title">Manage</span>
      </v-flex>
      <v-flex xs12>
        <v-divider/>
      </v-flex>
      <v-flex xs2 pt-4>
        <v-label>Name</v-label>
      </v-flex>
      <v-flex xs10>
        <v-text-field
          v-model="localAffiliate.name"
          placeholder="Name"
        />
      </v-flex>
      <v-flex xs2 pt-4>
        <v-label>Username</v-label>
      </v-flex>
      <v-flex xs10>
        <v-text-field
          v-model="localAffiliate.username"
          class="text-field-height-fix"
          placeholder="Username"
          hint="Must be at least 6 characters"
        />
      </v-flex>
      <v-flex xs2 pt-4>
        <v-label>Token</v-label>
      </v-flex>
      <v-flex xs10>
        <v-text-field
          v-model="localAffiliate.token"
          class="text-field-height-fix"
          placeholder="Token"
          hint="Must be at least 32 characters"
        >
          <template v-slot:append-outer>
            <v-btn color="primary" small @click="generateToken">
              Generate Token
            </v-btn>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex xs12 mt-2>
        <v-btn :disabled="!validInput" class="right" color="info" @click="saveAffiliate">
          Save
        </v-btn>
      </v-flex>
      <v-snackbar v-model="snackbarShow">{{ snackbarText }}</v-snackbar>
    </v-layout>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/components/Affiliates/AffiliatesManage.vue